export const gitVersion = {
  "commit": "eed07a2",
  "commitLong": "eed07a2c7c25e2c9e4f5fed1a12358fe2712b32e",
  "date": "2025-04-28T18:37:29.000Z",
  "buildNumber": "1993"
}